import type {
    ViewStyle
} from "react-native";
import type {
    FieldActionDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    currentSize,
    isMultiline,
    radiuses,
    borders,
    colors
}: FieldActionDynamicStyleType) => {
    const footprintHeight = isMultiline ? currentSize.lineHeight : currentSize.actionSize;

    const styles = {
        container: {
            marginHorizontal: (currentSize.iconSize - currentSize.actionHitSize) / 2,
            marginVertical: (footprintHeight - currentSize.actionHitSize) / 2,
            height: currentSize.actionHitSize,
            width: currentSize.actionHitSize
        } as Mutable<ViewStyle>,
        surface: {
            height: currentSize.actionSize,
            width: currentSize.actionSize,
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    delete styles.surface.outlineOffset;

    return styles;
};
